import { render, staticRenderFns } from "./ImageIcon.vue?vue&type=template&id=4a60f332&scoped=true"
import script from "./ImageIcon.vue?vue&type=script&lang=ts"
export * from "./ImageIcon.vue?vue&type=script&lang=ts"
import style0 from "./ImageIcon.vue?vue&type=style&index=0&id=4a60f332&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a60f332",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a60f332')) {
      api.createRecord('4a60f332', component.options)
    } else {
      api.reload('4a60f332', component.options)
    }
    module.hot.accept("./ImageIcon.vue?vue&type=template&id=4a60f332&scoped=true", function () {
      api.rerender('4a60f332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ImageIcon.vue"
export default component.exports